import React from "react";
import "./Footer.css";
import logo2 from "../../assets/logo2.jpg";

const Footer = () => {
  return (
    <div className="main-footer">
      <div className="main-footer1">
        <div className="footer1">
          <div className="footer2">
            <section className="section1">
              <i class="fas fa-map-marker-alt"></i>
            </section>
            <section className="section2">
              <h6>Find Us</h6>
              <p>City Vista Kharadi, Pune,Maharashtra 413304</p>
            </section>
          </div>
          <div className="footer2">
            <section className="section1">
              <i class="fas fa-phone-alt"></i>
            </section>
            <section className="section2">
              <h6>Call Us</h6>
              <p>+91 9172922622</p>
            </section>
          </div>

          <div className="footer2">
            <section className="section1">
              <i class="fal fa-envelope-open"></i>
            </section>
            <section className="section2">
              <h6>Mail Us</h6>
              <p>contact@careerphoenix.in</p>
            </section>
          </div>
        </div>
      </div>
      <div className="main-footer2">
        <div className="f2">
          <section className="f21">
            <img src={logo2} alt="" width="110px" />
          </section>
          <section className="f22">
            <h6>Follow us</h6>
            <section className="f221">
              <i class="fab fa-linkedin"></i>
              <i class="fab fa-twitter"></i>
              <i class="fab fa-facebook-square"></i>
              <i class="fab fa-instagram"></i>
              <i class="fab fa-youtube"></i>
            </section>
          </section>
        </div>
        <div className="f3">
          <h4>Useful Links</h4>
          <div className="f31">
            <ul>
              <li>Career Phoenix</li>
              <li>Youth</li>
              <li>R & D</li>
              <li>Internship</li>
            </ul>
            <ul>
              <li>RPTN</li>
              <li>Career</li>
              <li>RedPhanthom Group</li>
              <li>Update</li>
            </ul>

            {/* <section className="f32"> */}
            {/* </section>
              <section className="f32">
                
              </section> */}
          </div>
        </div>
        <div className="f4">
          <h4>Subscribe</h4>
          <div className="f41">
            <p>
              Don't miss to subscribe to our new feeds. Kindly fill-the <br />{" "}
              form below
            </p>
            <input type="email" placeholder="Email Address" />
            <i
              class="fas fa-paper-plane"
              style={{ background: "red", padding: "10px" }}
            ></i>
          </div>
        </div>
      </div>
      <div className="main-footer3">
        <section className="f5">
            <p>Copyrights @ 2022 All Rights Reserved by <span style={{color:"red"}}>RedPhanthom TechNovelty</span></p>
        </section>
        <ul>
            <li>Terms</li>
            <li>Policy</li>
            <li>FAQ's</li>
        </ul>
      </div>
    </div>
  );
};

export default Footer;
